// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import Icon from '@ant-design/icons';

import { FitIcon } from 'icons';
import { Canvas } from 'labelops-canvas-wrapper';
import LABELOPSTooltip from 'components/common/labelops-tooltip';

export interface Props {
    canvasInstance: Canvas;
}

function FitControl(props: Props): JSX.Element {
    const { canvasInstance } = props;

    return (
        <LABELOPSTooltip title='Fit the image [Double Click]' placement='right'>
            <Icon className='labelops-fit-control' component={FitIcon} onClick={(): void => canvasInstance.fit()} />
        </LABELOPSTooltip>
    );
}

export default React.memo(FitControl);
